export default "__VITE_ASSET__DpD9mUYO__"